import React, { useEffect, useState } from 'react';

import APDropdown from 'components/Dropdown/APDropdown';

const SOCIAL_OPTIONS = [
  { value: 'facebook', label: 'Facebook', prefix: 'https://www.facebook.com/' },
  { value: 'instagram', label: 'Instagram', prefix: 'https://www.instagram.com/' },
  { value: 'pinterest', label: 'Pinterest', prefix: 'https://www.pinterest.com/' },
  { value: 'twitter', label: 'Twitter', prefix: 'https://x.com/' },
  { value: 'youtube', label: 'YouTube', prefix: 'https://www.youtube.com/@' },
  { value: 'vimeo', label: 'Vimeo', prefix: 'https://vimeo.com/' },
];

const LeadRecordAdditionalContact = ({
  addEmail,
  addPhone,
  addAddress,
  addWebsite,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSocialOpen, setIsSocialOpen] = useState(false);

  const Button = (
    <button
      className="button--unstyled gold button--add"
      onClick={() => setIsOpen(true)}
    >
      Add contact info
    </button>
  );

  useEffect(() => {
    if (!isOpen) setIsSocialOpen(false);
  }, [isOpen]);

  return (
    <APDropdown
      isOpen={isOpen}
      root={null}
      triggerButton={Button}
      show={() => setIsOpen(true)}
      dismiss={() => setIsOpen(false)}
      placement="bottom-start"
    >
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addEmail();
        }}
      >
        Add additional email
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addPhone();
        }}
      >
        Add additional phone
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addAddress();
        }}
      >
        Add additional address
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => {
          setIsOpen(false);
          addWebsite();
        }}
      >
        Add additional website
      </button>
      <button
        className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
        onClick={() => setIsSocialOpen((prev) => !prev)}
      >
        Add social
      </button>
      {isSocialOpen && (
        <div className='linked-accounts__menu-sublist'>
          {SOCIAL_OPTIONS.map(({ value, label, prefix }) => (
            <button
              key={value}
              className='action_buttons__button button--unstyled button--menu linked-accounts__menu-item'
              onClick={() => {
                setIsOpen(false);
                addWebsite(prefix);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </APDropdown>
  );
};

export default LeadRecordAdditionalContact;
